import React from "react";
import { Container, Form, Button, Card } from "react-bootstrap";
import Logo from "../assets/images/logo.png";
import UserNameIcon from "../assets/images/username.svg";
import { useLocation } from "react-router-dom";
import { LOGIN, SAVE_FAVORITES,AGENTS_PORTAL } from "../api/constants";
import PasswordInput from "../component/PasswordInput";
import { useNavigate } from 'react-router-dom';

const STORAGE_KEY = "favoriteProperties";


function SignInContinue() {
  const navigate = useNavigate();
  const location = useLocation();
  const [password, setPassword] = React.useState('');
  const [username, setUsername] = React.useState(location.state?.username || '');
  const [error, setError] = React.useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check required fields
    if (!password || !username) {
      setError("Both username and password are required");
      return;
    }


    setError("");
    // Call your API to create account
    fetch(LOGIN, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        password,
        username,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        if (data.status) {
          //reset form
          setPassword('');
          setUsername('');
          //Go home
          if (data.data.user.role === "client") {
          localStorage.setItem("token", data.data.token);
          localStorage.setItem("expires_at", data.data.expires_at);
          localStorage.setItem("user", JSON.stringify(data.data.user));
          saveFavorite(data.data.token)
          navigate('/')
          }else if (data.data.user.role === "agent") {
            window.open(`${AGENTS_PORTAL}`, '_blank');
          }

        } else {
          setError(data.errors);
        }
      })
      .catch((error) => {
        console.error("Error creating account:", error);
        setError("Error creating account");
      });
  };
  const saveFavorite = async (token) => {

    const stored =
      JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    if (stored.length > 0) {
      fetch(SAVE_FAVORITES, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          properties: stored
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          if (data.status) {

            localStorage.removeItem(STORAGE_KEY)
          } else {
            //setError(data.errors);
          }
        })
        .catch((error) => {
          console.error("Error creating account:", error);
          setError("Error creating account");
        });
    }

  };


  return (
    <div className="login-sign-main common-padding" >
      <Container>
        <Card>
          <div className="login-sign-wrap">
            <img width={200} src={Logo} alt="" />
            <h3>Sign In</h3>
          </div>

          <Form>
            <Form.Group className="from-group mb-3">
              <Form.Control type="text" placeholder="Enter username" value={username} onChange={(e) => setUsername(e.target.value)} />
              <img src={UserNameIcon} alt="" />
            </Form.Group>
            <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)} />
            <p className="mt-3 mb-3 text-start">
              <a href="/forgot-password">
                Forgot Password?
              </a>
            </p>
            <Button className="custom-bttn style-3 w-100 mt-3" onClick={handleSubmit}>
              Continue
            </Button>
            <p className="text-danger">
              {error}
            </p>

            <p>
              New to Jambobay?{" "}
              <a href="/create-account">
                Create account
              </a>
            </p>
            {/* <div className="text-center or-div m-0 min-h-auto"></div>
            <p className="mb-0">
              <a href="/terms">
                Or send a secure code to your email
              </a>
            </p> */}
          </Form>
        </Card>
      </Container>
    </div>
  );
}

export default SignInContinue;
